import { useCallback } from "react";
import { onHomeConnectSMClick } from "../analytics/analytics.click-handlers";
import Colors from "../assets/constants/Colors";
import { Spacers } from "../assets/constants/Spacers";
import {
  appLinks,
  connectTitleId
} from "../assets/constants/Strings";
import { linkedinLogo } from "../assets/images";
import styled from "../styled-components";
import { Social } from "../types";
import { homeContent } from "./Home.constants";

const { pageContent } = Spacers;

const Connect = () => {

  const linkedinClicked = useCallback(() => onHomeConnectSMClick({
    href: appLinks.linkedin,
    type: Social.linkedin,
    img: linkedinLogo,
  }),[])

  return (
    <PageContainer>
      <PageContentContainer>
        
        <SectionTitleText id={connectTitleId}>
          {homeContent.connectTitle}
        </SectionTitleText>
        <PageSectionContainer>
          <BodyText>
            {homeContent.connect_line1_0}
            <a onClick={linkedinClicked} href={appLinks.linkedin} target="_blank" rel="noreferrer">
              {homeContent.connect_line1_1} <ConnectLinkIcon src={linkedinLogo} />
            </a>
            .
          </BodyText>
          <BodyText>{"I am currently open to remote projects in "}<b>{"Data Analytics"}</b>{", "}<b>{"Project Managment"}</b>{", or a related "}<b>{"Business Development"}</b>{" / "}<b>{"Analyst"}</b>{" / "}<b>{"Admin"}</b>{" role."}</BodyText>
          <BodyText>{"Along with remote work, I am open to in-person or hybrid opportunities in and around the Santa Clarita and San Fernando Valley areas of California."}</BodyText>
          <BodyText>{"Hybrid projects in the Greater Los Angeles region are also a good fit."}</BodyText>
        </PageSectionContainer>
        
      </PageContentContainer>
    </PageContainer>
  );
};
export default Connect;

export const cardStyles = {
  alignItems: "center",
  backgroundColor: Colors.surfaceForeground,
  borderColor: Colors.surfaceForegroundBorder,
  marginBottom: "15px",
};

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const PageContentContainer = styled.div`
  width: 100%;
  max-width: ${pageContent.maxWidth.px};
  margin: 0 auto;
  padding: ${pageContent.padding.top.px} ${pageContent.padding.horizontal.px} ${pageContent.padding.bottom.px};
  overflow: auto;
`;

const PageSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 25px;
`;

const ConnectLinkIcon = styled.img`
  width: 15px;
  height: 15px;
  padding: 2px;
`;

const SectionTitleText = styled.h2``;

const BodyText = styled.p``;
